import { render, staticRenderFns } from "./YzCheckboxSelectionCard.vue?vue&type=template&id=4f87a43c&scoped=true&lang=pug&"
import script from "./YzCheckboxSelectionCard.vue?vue&type=script&lang=js&"
export * from "./YzCheckboxSelectionCard.vue?vue&type=script&lang=js&"
import style0 from "./YzCheckboxSelectionCard.vue?vue&type=style&index=0&id=4f87a43c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f87a43c",
  null
  
)

export default component.exports